import React from 'react'
import { DI } from 'modules'

class HTMLTranslation extends React.Component {
  render() {
    const Cmp =
      this.props.translations[this.props.common.locale] || (() => null)

    return <Cmp {...this.props} />
  }
}

export default DI([])(HTMLTranslation)
